import { Action } from '@ngrx/store';

import { PageResource } from './page-resource';

export enum PageContentActionTypes {
  FETCH_PAGE_CONTENT = '[Page Content] Fetch Page Content',
  FETCH_PAGE_CONTENT_SUCCESS = '[Page Content] Fetch Page Content Success',
  FETCH_PAGE_CONTENT_FAILED = '[Page Content] Fetch Page Content Failed',
}

export interface PageIdPayload {
  pageId: string;
}

export class FetchPageContentAction implements Action {
  readonly type = PageContentActionTypes.FETCH_PAGE_CONTENT;

  constructor(public payload: PageIdPayload) {}
}

export interface PageContentAndIdPayload extends PageIdPayload {
  pageContent: PageResource;
}

export class FetchPageContentSuccessAction implements Action {
  readonly type = PageContentActionTypes.FETCH_PAGE_CONTENT_SUCCESS;

  constructor(public payload: PageContentAndIdPayload) {}
}

export interface PageContentErrorAndIdPayload extends PageIdPayload {
  error: any;
}

export class FetchPageContentFailedAction implements Action {
  readonly type = PageContentActionTypes.FETCH_PAGE_CONTENT_FAILED;

  constructor(public payload: PageContentErrorAndIdPayload) {}
}

export type PageContentActions =
  | FetchPageContentAction
  | FetchPageContentSuccessAction
  | FetchPageContentFailedAction;
